<template>
<div style="width: 100%; height: 0px; border-top: 0.5px solid #CCCCCC;" :class="[margin !== 'LINE-CODE' || !margin ? margin : 'margin-y-16x24']">
</div>
</template>
<script>
export default {
    name: 'LineCode',
    props: {
        margin: {
            type: String,
            default: 'margin-y-16x24'
        }
    },
}
</script>
<style>
.margin-y-16x24 {
    margin: 16px 0px 24px 0px;
}
.margin-y-16x16 {
    margin: 16px 0px 16px 0px;
}
</style>